(function () {
  function parseStart(raw) {
    if (!raw) return null;

    // Eğer sayı geldiyse: epoch saniye/ms ihtimali
    if (/^\d+$/.test(raw)) {
      var n = Number(raw);
      if (!isFinite(n)) return null;
      // 10 haneli ise saniye, 13 haneli ise ms varsay
      if (raw.length <= 10) return new Date(n * 1000);
      return new Date(n);
    }

    // ISO / tarih string
    var d = new Date(raw);
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function pad2(n) {
    n = Math.max(0, n | 0);
    return n < 10 ? "0" + n : "" + n;
  }

  function formatDiff(ms) {
    var total = Math.floor(ms / 1000);
    var days = Math.floor(total / 86400);
    total -= days * 86400;
    var hours = Math.floor(total / 3600);
    total -= hours * 3600;
    var mins = Math.floor(total / 60);
    var secs = total - mins * 60;

    // Gün varsa: 2g 03:12:08 gibi
    if (days > 0) return days + "g " + pad2(hours) + ":" + pad2(mins) + ":" + pad2(secs);
    return pad2(hours) + ":" + pad2(mins) + ":" + pad2(secs);
  }

  function setLiveState(el, isLive) {
    if (!el) return;

    if (isLive) el.classList.add("fi-started");
    else el.classList.remove("fi-started");

    // Ürün detay başlık toggle (varsa)
    var upcoming = el.querySelector("[data-fi-title-upcoming]");
    var live = el.querySelector("[data-fi-title-live]");
    if (upcoming && live) {
      if (isLive) {
        upcoming.style.display = "none";
        live.style.display = "";
      } else {
        upcoming.style.display = "";
        live.style.display = "none";
      }
    }
  }

  function tickOne(el) {
    var raw = el.getAttribute("data-start");
    var start = parseStart(raw);
    if (!start) return;

    var timer = el.querySelector("[data-fi-timer]");
    if (!timer) return;

    function update() {
      var now = new Date();
      var diff = start.getTime() - now.getTime();

      if (diff <= 0) {
        timer.textContent = "Başladı";
        setLiveState(el, true);
        return;
      }

      setLiveState(el, false);
      timer.textContent = formatDiff(diff);
    }

    update();
    // her sayaç için interval
    var id = setInterval(function () {
      update();
      if (timer.textContent === "Başladı") clearInterval(id);
    }, 1000);
  }

  function init() {
    var nodes = document.querySelectorAll("[data-fi-countdown][data-start]");
    if (!nodes.length) return;
    nodes.forEach(tickOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
